import { useContext } from "react";
import { useQuery } from "react-query";
import "./cases.scss"
import { Link } from "react-router-dom";
import api  from "../../services/api";
import { AuthContext } from "../../context/authContext"
import { useEffect, useState } from "react";

const fetchCases = async () => {
  const res = await api.get(`/api/osint/list_cases/`);
  return res.data;   
};

const CasesFancyList = () => {
  const {
    data: cases,
    isLoading,
    error,
  } = useQuery("cases", fetchCases);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  
  const sortedCases = [...cases].sort((a, b) => a.name.localeCompare(b.name));
  const groupedCases = sortedCases.reduce((groups, _case) => {
    const firstChar = _case.name.charAt(0).toUpperCase();
    if (!groups[firstChar]) {
      groups[firstChar] = [];
    }
    groups[firstChar].push(_case);
    return groups;
  }, {});
  const groupKeys = Object.keys(groupedCases).sort();
  return (
    <>
    <div className="group-navigation">
      {groupKeys.map((group) => (
        <a key={group} href={`#group-${group}`} style={{ marginRight: '10px' }}>
          {group}
        </a>
      ))}
    </div>
    <div className="casesBanner">
      <div className="case">
          <img src="/images/new_case.png" alt="" />
          <Link to="/cases/new" className="newCaseButton"><button>+</button></Link>
      </div>
      </div>
      <div className="casesBanner">
      {groupKeys.map((group) => (
        <div key={group} id={`group-${group}`} className="group">
          <span>{group}</span>
          {groupedCases[group].map((_case) => (
            <div className="case" key={_case.id}>
              <img src={_case.img? _case.img : "/images/case_default_cover.png"} alt="" />
              <span><Link
                    to={`/case/${_case.id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >{_case.name}</Link></span>
            </div>
          ))}
          {/* Back to top link */}
          <div>
          <a href="#top" style={{ marginTop: '10px' }}>
            Back to top
          </a>
          </div>
        </div>
      ))}
    </div>
    </>
  )
 
}

export default CasesFancyList